(() => {
  if (window.collectionFilterDrawerGestureInitialized) return;
  window.collectionFilterDrawerGestureInitialized = true;

  const selectors = {
    drawer: '[data-collection-filters]',
    wrapper: '[data-collection-filters-wrapper]',
    handle: '[data-filter-drawer-handle]',
    backdrop: '.collection__filters-backdrop',
    close: '[data-close-filters]:not(.collection__filters-backdrop)',
  };

  const classes = {
    dragging: 'is-dragging',
    visible: 'collection__filters--visible',
  };

  const mobileBreakpoint = 768;
  const transitionDuration = 300;
  let gesture = null;

  const clearInlineStyles = ({wrapper, backdrop}) => {
    wrapper.style.removeProperty('transition');
    wrapper.style.removeProperty('transform');
    backdrop?.style.removeProperty('transition');
    backdrop?.style.removeProperty('opacity');
  };

  const finishGesture = (shouldClose) => {
    if (!gesture) return;

    const currentGesture = gesture;
    const {drawer, wrapper, backdrop} = currentGesture;
    gesture = null;

    wrapper.classList.remove(classes.dragging);
    wrapper.style.transition = `transform ${transitionDuration}ms cubic-bezier(0.46, 0.01, 0.32, 1)`;
    if (backdrop) backdrop.style.transition = `opacity ${transitionDuration}ms ease-in-out`;

    requestAnimationFrame(() => {
      wrapper.style.transform = shouldClose ? 'translateY(100%)' : 'translateY(0)';
      if (backdrop) backdrop.style.opacity = shouldClose ? '0' : '1';
    });

    window.setTimeout(() => {
      if (shouldClose && drawer.classList.contains(classes.visible)) {
        const closeButton = drawer.querySelector(selectors.close) || drawer.querySelector(selectors.backdrop);
        closeButton?.click();
      }
      clearInlineStyles(currentGesture);
    }, transitionDuration);
  };

  document.addEventListener('pointerdown', (event) => {
    const handle = event.target.closest(selectors.handle);
    if (!handle || window.innerWidth >= mobileBreakpoint || event.button !== 0) return;

    const drawer = handle.closest(selectors.drawer);
    const wrapper = handle.closest(selectors.wrapper);
    if (!drawer || !wrapper || !drawer.classList.contains(classes.visible)) return;

    const backdrop = drawer.querySelector(selectors.backdrop);
    gesture = {
      drawer,
      wrapper,
      backdrop,
      pointerId: event.pointerId,
      startY: event.clientY,
      currentY: event.clientY,
      startTime: performance.now(),
    };

    wrapper.classList.add(classes.dragging);
    wrapper.style.transition = 'none';
    if (backdrop) backdrop.style.transition = 'none';
    handle.setPointerCapture?.(event.pointerId);
    event.preventDefault();
  });

  document.addEventListener('pointermove', (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;

    gesture.currentY = event.clientY;
    const distance = Math.max(0, gesture.currentY - gesture.startY);
    const progress = Math.min(distance / gesture.wrapper.offsetHeight, 1);

    gesture.wrapper.style.transform = `translateY(${distance}px)`;
    if (gesture.backdrop) gesture.backdrop.style.opacity = `${Math.max(0, 1 - progress)}`;
    event.preventDefault();
  }, {passive: false});

  document.addEventListener('pointerup', (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;

    const distance = Math.max(0, gesture.currentY - gesture.startY);
    const elapsed = Math.max(performance.now() - gesture.startTime, 1);
    const velocity = distance / elapsed;
    const threshold = Math.min(100, gesture.wrapper.offsetHeight * 0.18);
    const shouldClose = distance >= threshold || (distance > 24 && velocity > 0.6);

    finishGesture(shouldClose);
  });

  document.addEventListener('pointercancel', (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    finishGesture(false);
  });
})();
